import { render, staticRenderFns } from "./summarize-modal.vue?vue&type=template&id=fa304d06&scoped=true"
import script from "./summarize-modal.vue?vue&type=script&lang=js"
export * from "./summarize-modal.vue?vue&type=script&lang=js"
import style0 from "./summarize-modal.vue?vue&type=style&index=0&id=fa304d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa304d06",
  null
  
)

export default component.exports